module.exports = __webpack_public_path__ + "static/media/404-error.d6414345.png";